import http from "@/axios";
import {LevelUpDto} from './types';
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";

export default class LevelStore {

    public static fetchLevelUpDto(): Promise<LevelUpDto> {
        return http.get('/api/level/info')
            .then(r => r.data)
            .then(rObj => {
                return Object.assign(new LevelUpDto(), rObj);
            });
    }

    public static levelUpChosenCreature(creatureId: number): Promise<Player>{
        let params = new URLSearchParams();
        params.append('creatureId', String(creatureId));
        return http.post('/api/level/up', params)
            .then(r => r.data)
            .then(playerObj => {
                let player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

}
